export const editIconSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5264 5.41797C15.8209 5.17766 16.2557 5.19512 16.5303 5.46973L18.5303 7.46973C18.8232 7.76262 18.8232 8.23738 18.5303 8.53027L9.53027 17.5303C9.44794 17.6126 9.34776 17.6751 9.2373 17.7119L6.2373 18.7119C5.9678 18.8017 5.6706 18.7311 5.46973 18.5303C5.26885 18.3294 5.19825 18.0322 5.28809 17.7627L6.28809 14.7627C6.32491 14.6522 6.3874 14.5521 6.46973 14.4697L15.4697 5.46973L15.5264 5.41797Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M14 8L16 10" stroke="currentColor" stroke-width="1.5"/>
</svg>`

const EditIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M15.5264 5.41797C15.8209 5.17766 16.2557 5.19512 16.5303 5.46973L18.5303 7.46973C18.8232 7.76262 18.8232 8.23738 18.5303 8.53027L9.53027 17.5303C9.44794 17.6126 9.34776 17.6751 9.2373 17.7119L6.2373 18.7119C5.9678 18.8017 5.6706 18.7311 5.46973 18.5303C5.26885 18.3294 5.19825 18.0322 5.28809 17.7627L6.28809 14.7627C6.32491 14.6522 6.3874 14.5521 6.46973 14.4697L15.4697 5.46973L15.5264 5.41797Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path d="M14 8L16 10" stroke={color} strokeWidth="1.5" />
        </svg>
    )
}

export default EditIcon
